import { Box, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Bar, Line } from 'react-chartjs-2'
import { useLocation } from 'react-router-dom'
import WTypography from '../../../../../Components/whiteTypography'
import { deviseCal } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

let click = false
function LineChart({ barData, barHeaderValue, setData, slug }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const getAppStore = useSelector((store) => store.appStore).appStore
  const user = useSelector((store) => store.user?.user)

  // LAP-733 (GE022) — derive labels via i18next
  const getGroupingText = () => {
    const viewType = getAppStore?.viewType || 'Global'
    const operation = slug === 'R' ? t('dashboardDetail.incomeLower') : t('dashboardDetail.expensesLower')
    let grouping = t('dashboardDetail.category')
    if (viewType === 'Category') grouping = t('dashboardDetail.subcategory')
    else if (viewType === 'Accounts') grouping = t('dashboardDetail.accounts')
    return t('dashboardDetail.breakdownBy', { operation, grouping: grouping.toLowerCase() })
  }
  // console.log(barData)
  // const [data, setDatab] = useState(barData)
  const siteDevise = useSelector((store) => store.devise)
  // useEffect(() => {
  //   console.log(barData)
  //   setDatab({ ...barData })
  // }, [barData])
  // useEffect(() => {
  //   let dv = []
  //   data?.datasets[0].data.forEach((e, i) => {
  //     dv.push(deviseCal(e, siteDevise.devise.to_eur))
  //   })
  //   setData({ ...data, datasets: [{ ...data.datasets[0], data: dv }] })
  //   console.log(data)
  // }, [siteDevise])
  // console.log(data)
  const location = useLocation()
  const optionsbar = {
    indexAxis: 'x',
    aspectRatio: 3.3,
    responsive: true,

    onClick: (event, elements) => {
      click = !click
      if (elements.length > 0 && click) {
        setData(`chart_click=${barData.labels[elements[0].index]}`)
      } else if (click === false) {
        setData(location.search.slice(1))
      }
    },

    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    elements: {
      bar: {
        borderWidth: 2,
      },
    },

    plugins: {
      datalabels: { color: 'white' },
      // legend: {
      //   display: 'none',
      // },
      //   title: {
      //     display: false,
      //     text: 'Mon cashflow',
      //   },
      legend: {
        display: slug === 'R' || slug === 'D' ? getAppStore.legend : false,
        position: 'right',
        labels: {
          color: 'white',
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
    scales: {
      x: {
        ticks: { color: 'white' },
      },
      y: {
        ticks: { color: 'white' },
      },
    },
  }
  return (
    <Card className="dashboard_card__root">
      <Box className="dashboard_card__header">
        <WTypography component={'span'} variant="h5">
          {slug === 'R' ? t('dashboardDetail.income') : t('dashboardDetail.expenses')}
        </WTypography>
        <WTypography component={'span'} variant="h5">
          {barHeaderValue === null ? 0 : deviseCal(barHeaderValue, siteDevise.devise.to_eur)}
        </WTypography>
      </Box>

      <WTypography variant={'body2'}>
        {getGroupingText()}
      </WTypography>
      <Box mt={2} minWidth={3} className={getAppStore.expandChart ? '' : 'height-500'}>
        {barHeaderValue === null || barHeaderValue === 0 ? (
          <WTypography variant="h6" align="center">
            {t('dashboardDetail.noData')}
          </WTypography>
        ) : (
          <Line data={barData} height={'270%'} options={optionsbar} />
        )}
      </Box>
    </Card>
  )
}

export default LineChart
